import { useQueryClient } from '@tanstack/react-query';

import useAPI from '@/hooks/useAPI';
import WorkRepository from '@/repositories/WorkRepository';

export const useItemByKustomerEventId = ({
  kustomerEventId,
  enabled = true
}: {
  kustomerEventId?: string | null;
  enabled?: boolean;
}) => {
  const queryClient = useQueryClient();
  const workRepository = WorkRepository();

  return useAPI({
    enabled,
    queryKey: ['getTaskByKustomerEventId', kustomerEventId],
    queryFn: async () => {
      if (!kustomerEventId) return;

      const response = await workRepository.getItemByKustomerEventId(kustomerEventId);
      // Seed the item cache from this fetch only. Seeding on render would put this
      // snapshot back over any later update to the item, e.g. claiming it.
      if (response.data?.id) queryClient.setQueryData(['getItem', response.data.id], response);
      return response;
    }
  });
};
